import { Col, List, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { coreApi } from "../api/calls";
import Contact from "./Contact";
import ContactAddForm from "./ContactAddForm";

const ContactsPane = ({ props, contacts, contactable, allContacts = null }) => {
  // Translations
  const { t } = useTranslation();

  // States
  const [contactsState, setContactsState] = useState([]);
  const [tags, setTags] = useState([]);
  const [contactsStats, setContactsStats] = useState({});

  useEffect(() => {
    coreApi
      .get("contacts/tags")
      .then((response) => {
        setTags(response.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    setContactsState(Array.isArray(contacts) ? contacts : []);
  }, [contacts]);

  useEffect(() => {
    if (contactsState.length > 0) {
      const contactIds = contactsState.map(c => c.id).filter(Boolean);
      
      if (contactIds.length > 0) {
        coreApi
          .post("contacts/buildings-count", { contact_ids: contactIds })
          .then((response) => {
            // Expected response format: { "5667": 3, "5668": 1, ... }
            setContactsStats(response.data);
          })
          .catch((e) => console.log(e));
      }
    }
  }, [contactsState]);

  /**
   * Create a new contact from values.
   *
   * @param {array} values
   */
  const addContact = (values) => {
    let payload = { ...values, ...{ contactable: contactable } };

    coreApi
      .post("contacts", payload)
      .then((res) => {
        setContactsState([...contactsState, res.data.contact]);
        notification.success({ message: res.data.message });
      })
      .catch((error) => console.log(error));
  };

  /**
   * Add an existing contact to the contactable.
   *
   * @param {array} values
   */
  const addExistingContact = (values) => {
    let payload = { ...values, ...{ contactable: contactable } };

    coreApi
      .put("contacts/" + values?.contact_id + "/assign-to-contactable", payload)
      .then((res) => {
        notification.success({ message: res.data.message });
        setContactsState([...contactsState, res.data.contact]);
      })
      .catch((error) => console.log(error));
  };

  /**
   * Update a contact from values.
   *
   * @param {array} values
   */
  const updateContact = (values) => {
    let payload = { ...values, ...{ contactable: contactable } };

    coreApi
      .put("/contacts/" + values?.contact_id, payload)
      .then((res) => {
        let contacts = Array.isArray(contactsState) ? [...contactsState] : [];

        let index = contacts.findIndex((el) => el.id === res.data?.contact?.id);
        if (index !== -1) {
          contacts[index] = res.data?.contact;
        }
        setContactsState(contacts);

        notification.success({ message: res.data.message });
      })
      .catch((error) => console.log(error));
  };

  /**
   * Delete a contact from the contactable.
   *
   * @param {array} values
   */
  const deleteContactRelation = (values) => {
    let payload = { ...values, ...{ contactable: contactable } };

    coreApi
      .delete("contacts/" + values?.contact_id + "/unassign-contactable", {
        data: payload,
      })
      .then((res) => {
        notification.success({ message: res.data.message });
        let newContacts = contactsState.filter((contact) => contact?.id !== values.contact_id);
        setContactsState(newContacts);
      })
      .catch((error) => console.log(error));
  };

  /**
   * Delete the selected contact.
   *
   * @param {array} contact
   */
  const deleteContact = (contact) => {
    coreApi
      .delete("contacts/" + contact?.id)
      .then((res) => {
        let deleted = contactsState.filter((item) => item?.id !== contact?.id);
        setContactsState([...deleted]);
        notification.success({
          message: t("common.recordDeleted"),
        });
      })
      .catch((error) => console.log(error));
  };

  return (
    <React.Fragment>
      <List
        size="small"
        header={
          <div
            style={{
              height: "100%",
              background: "#fafafa",
              margin: "-12px",
              paddingTop: "12px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            <Row>
              <Col span={3}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.name")}</h4>
              </Col>
              <Col span={2}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.numberOfObjects")}</h4>
              </Col>
              <Col span={3}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.email")}</h4>
              </Col>
              <Col span={3}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.phone")}</h4>
              </Col>
              <Col span={3}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.companyName")}</h4>
              </Col>
              <Col span={4}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.contactType")}</h4>
              </Col>
              <Col span={4}>
                <h4 style={{ textAlign: "center" }}>{t("contacts.notesInfo")}</h4>
              </Col>
              <Col span={2}>
                <h4 style={{ textAlign: "center" }}>{t("common.actions")}</h4>
              </Col>
            </Row>
          </div>
        }
        itemLayout="horizontal"
        dataSource={contactsState}
        renderItem={(item) => {
          let unitId = {
            match: {
              params: {
                id: item?.id,
              },
            },
          };

          return (
            <List.Item style={{paddingLeft: "8px", paddingRight: "8px"}}>
              <Contact
                props={allContacts ? unitId : props}
                contact={item}
                updateContact={updateContact}
                deleteContact={deleteContact}
                deleteContactRelation={deleteContactRelation}
                tags={tags}
                buildingsCount={contactsStats[item.id] || 0}
              ></Contact>
            </List.Item>
          );
        }}
      ></List>

      {contactable?.id && (
        <ContactAddForm
          ctAddForm
          onFinishAction={addContact}
          addExisting={addExistingContact}
          tags={tags}
          contactable={contactable}
        ></ContactAddForm>
      )}
    </React.Fragment>
  );
};

export default ContactsPane;
